(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["has-image-gellery"] && !Shopify.designMode) return;
  try {
    
class FullWidthGallery {
  constructor() {
    this.initLazyLoading();
  }
  
  initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const images = document.querySelectorAll('.gallery-image-wrapper img');
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.classList.add('visible');
            imageObserver.unobserve(img);
          }
        });
      });
      
      images.forEach(img => imageObserver.observe(img));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FullWidthGallery();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["has-logo-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLogoSlider() {
      const sliders = document.querySelectorAll('.logo-slider-wrapper');
      
      sliders.forEach(slider => {
        const track = slider.querySelector('.logo-slider-track');
        if (!track) return;
        
        const speed = parseInt(slider.dataset.speed, 10) || 30;
        const direction = slider.dataset.direction || 'right';
        const gap = parseInt(slider.dataset.gap, 10) || 20;
        const isInfinite = slider.dataset.duplicated === 'true';
        
        // Get all slides (both groups)
        let slides = Array.from(track.querySelectorAll('.logo-slide'));
        
        if (slides.length === 0) return;
        
        // Calculate total width of a single group
        const group = track.querySelector('.primary-group');
        if (!group) return;
        
        const groupWidth = group.offsetWidth;
        
        // Set initial position based on direction
        let currentPosition = 0;
        
        if (direction === 'right') {
          // Right to left scrolling
          currentPosition = 0;
          track.style.transform = `translateX(0px)`;
        } else {
          // Left to right scrolling
          currentPosition = -groupWidth;
          track.style.transform = `translateX(${currentPosition}px)`;
        }
        
        let animationId = null;
        let lastTimestamp = 0;
        let pixelsPerSecond = 0;
        
        // Calculate pixels per second based on group width and desired speed
        // Speed is seconds per full cycle (group width)
        function updateSpeed() {
          const groupWidthCurrent = group.offsetWidth;
          pixelsPerSecond = groupWidthCurrent / speed;
        }
        
        updateSpeed();
        
        // Handle resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            updateSpeed();
            // Reset position when resizing to avoid glitches
            if (direction === 'right') {
              currentPosition = 0;
              track.style.transform = `translateX(0px)`;
            } else {
              currentPosition = -group.offsetWidth;
              track.style.transform = `translateX(${currentPosition}px)`;
            }
          }, 150);
        });
        
        function animate(timestamp) {
          if (!lastTimestamp) {
            lastTimestamp = timestamp;
            animationId = requestAnimationFrame(animate);
            return;
          }
          
          const delta = Math.min(100, timestamp - lastTimestamp); // Cap delta to 100ms
          const deltaSeconds = delta / 1000;
          
          if (direction === 'right') {
            // Right to left (move left)
            currentPosition -= pixelsPerSecond * deltaSeconds;
            
            // Reset when we've scrolled past one group width
            if (isInfinite && Math.abs(currentPosition) >= group.offsetWidth) {
              currentPosition = currentPosition % group.offsetWidth;
            }
          } else {
            // Left to right (move right)
            currentPosition += pixelsPerSecond * deltaSeconds;
            
            // Reset when we've scrolled past one group width
            if (isInfinite && currentPosition >= 0) {
              currentPosition = -group.offsetWidth + (currentPosition % group.offsetWidth);
            }
          }
          
          track.style.transform = `translateX(${currentPosition}px)`;
          
          lastTimestamp = timestamp;
          animationId = requestAnimationFrame(animate);
        }
        
        function startAnimation() {
          if (animationId) cancelAnimationFrame(animationId);
          lastTimestamp = 0;
          animationId = requestAnimationFrame(animate);
        }
        
        function stopAnimation() {
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        }
        
        // Pause on hover if enabled
        if (slider.dataset.pauseHover === 'true') {
          slider.addEventListener('mouseenter', stopAnimation);
          slider.addEventListener('mouseleave', startAnimation);
        }
        
        // Start the animation
        startAnimation();
        
        // Store animation reference on slider for cleanup
        slider._stopAnimation = stopAnimation;
      });
    }
    
    // Initialize staggered animation delay for slides
    const initStaggeredAnimation = () => {
      const slides = document.querySelectorAll('.logo-slide');
      slides.forEach((slide, index) => {
        slide.style.setProperty('--index', index);
      });
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initLogoSlider();
        initStaggeredAnimation();
      });
    } else {
      initLogoSlider();
      initStaggeredAnimation();
    }
    
    // Reinitialize if section is dynamically added (for Shopify's theme editor)
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId) {
          setTimeout(() => {
            initLogoSlider();
            initStaggeredAnimation();
          }, 100);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
